<main>
  <header>
    <h1>Link Your Bank Account</h1>
    <h2>We need to verify your bank account to securely process your payments. This step usually takes a few minutes.</h2>
  </header>
  
  <form class="application-form" [formGroup]="form" (ngSubmit)="continue()" appPopulateForm [formType]="'linkBankAccount'" [form]="form">
    
    @if (bankConnected) {
      <div class="success-message">
        <span>Account linked successfully!</span>
      </div>
    } @else {
      <div class="bank-connection-section">
        <button
          mat-stroked-button
          color="primary"
          type="button"
          (click)="initPlaidLink()"
          [disabled]="bankConnected || plaidLinkActive">
          @if (plaidLinkActive) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <span>+ Link an account</span>
          }
        </button>
        <div class="bank-not-listed-section">
          <h3>Can't find your financial institution?</h3>
          <h2>We require you to upload bank documents to verify account balances and ownership.</h2>
          <h2>Please select the checkbox below and send an email to <a href="mailto:underwriting&#64;transendfinancial.com">underwriting&#64;transendfinancial.com</a> including a voided check and your last three months of bank statements.</h2>
          <mat-checkbox formControlName="bankNotInPlaid" class="bank-not-in-plaid" style="margin-top: 20px;">
            My Bank Institution is not listed
          </mat-checkbox>
        </div>
      </div>
    }
    
    <app-form-actions
      [isFormInvalid]="!(bankConnected || form.get('bankNotInPlaid')?.value) || plaidLinkActive"
      (continue)="continue()"
      (back)="goBack()">
    </app-form-actions>
  </form>
</main>